export default "__VITE_ASSET__ChPnLhMQ__"